import React from "react";
import { motion } from "framer-motion";
import {
  FaWifi,
  FaSimCard,
  FaPhoneAlt,
  FaNetworkWired,
  FaPhoneVolume,
  FaUsersCog,
  FaTools,
  FaPaintBrush,
  FaBullhorn,
  FaRobot,
  FaLaptopCode
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./PlansLanding.css";

export default function PlansLanding(): JSX.Element {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => navigate(path), 500);
  };

  return (
    <main className="plans-landing-page">
      {/* Hero Section */}
      <motion.section
        className="plans-landing-hero"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1>Your Connection, Your Way</h1>
        <p>
          Choose the right Jortel plan to keep you connected  whether at home,
          on the go, or in the office.
        </p>
      </motion.section>

      {/* Grid of Plan Cards */}
      <motion.div
        className="plans-grid"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        {/* Mobile & Data Plans */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/mobile")}
        >
          <FaSimCard className="plan-icon" />
          <h2>J-Mobile Voice & Data</h2>
          <p>
            Stay connected with data banking, flexible sharing, and 5G access 
            built for modern life.
          </p>
          <button className="btn primary">Explore Mobile Plans </button>
        </motion.div>

        {/* NBN Internet Plans */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/nbn")}
        >
          <FaWifi className="plan-icon" />
          <h2>J-Data NBN</h2>
          <p>
Business-grade speed and stability with unlimited data, Static IP, and zero CG-NAT limitations.
          </p>
          <button className="btn primary">Explore NBN Plans </button>
        </motion.div>

{/* Business Fibre */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/business-fibre")}
        >
          <FaNetworkWired className="plan-icon" />
          <h2>J-Data Fibre</h2>
          <p>
            Premium Layer 3 fibre from 250 Mbps to 10 Gbps with static IP
            options and enterprise SLAs.
          </p>
          <button className="btn primary">Explore Business Fibre </button>
        </motion.div>

        {/* SIP Trunking */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/sip-trunking")}
        >
          <FaNetworkWired className="plan-icon" />
          <h2>J-Voice SIP</h2>
          <p>
            Scalable SIP channels with local number support, crystal-clear
            voice, and flexible pricing  built for business growth.
          </p>
          <button className="btn primary">Explore SIP Trunking </button>
        </motion.div>


{/* Hosted Voice */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/hosted-voice")}
        >
          <FaPhoneAlt className="plan-icon" />
          <h2>J-Voice Hosted</h2>
          <p>
            Cloud-hosted PBX solutions with call recording, auto attendants,
            and business-grade reliability  perfect for small offices.
          </p>
          <button className="btn primary">Explore Hosted Voice </button>
        </motion.div>

{/* Hosted Teams */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/hosted-teams")}
        >
          <FaUsersCog className="plan-icon" />
          <h2>J-Voice Microsoft Teams </h2>
          <p>
            Direct Routing, PAYG or Value Calling, and full integration with Microsoft Teams.
          </p>
          <button className="btn primary">Explore Hosted Teams </button>
        </motion.div>

 {/* Keeping Up With Technology */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/keep-up-with-technology")}
        >
          <FaTools className="plan-icon" />
          <h2>Keep Up With Technology</h2>
          <p>
            Flexible handset replacement, maintenance coverage, and upgrade options
            to keep your phone system modern and reliable.
          </p>
          <button className="btn primary">Explore KUWT </button>
        </motion.div>

        {/* Inbound Call Services */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/inbound-calls")}
        >
          <FaPhoneVolume className="plan-icon" />
          <h2>J-Voice Inbound</h2>
          <p>
            1300 & 1800 business inbound call routing with per-second billing
            and competitive wholesale rates.
          </p>
          <button className="btn primary">Explore Inbound Calls </button>
        </motion.div>

        {/* Technical Work (placeholder) */}
        <motion.div
          className="plan-card soon"
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <FaLaptopCode className="plan-icon" />
          <h2>Technical Work</h2>
          <p>
            Specialised technical projects, scoped and delivered by the Jortel team.
          </p>
          <button className="btn primary" disabled>Coming soon</button>
        </motion.div>

        {/* AI (coming soon) */}
        <motion.div
          className="plan-card soon"
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <FaRobot className="plan-icon" />
          <h2>AI Services</h2>
          <p>
            Intelligent automation and customer experiences powered by AI.
          </p>
          <button className="btn primary" disabled>Coming soon</button>
        </motion.div>

        {/* Web Design & Development */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/web-design")}
        >
          <FaPaintBrush className="plan-icon" />
          <h2>Web Design & Development</h2>
          <p>
            Modern sites, refreshed branding, and polished assets tailored to your campaigns.
          </p>
          <button className="btn primary">View Design Services </button>
        </motion.div>

        {/* Digital Marketing */}
        <motion.div
          className="plan-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={() => handleNavigate("/plans/social-media-marketing")}
        >
          <FaBullhorn className="plan-icon" />
          <h2>Digital Marketing</h2>
          <p>
            Campaign strategy, content calendars, and reporting to grow your audience.
          </p>
          <button className="btn primary">Explore Social Plans </button>
        </motion.div>



      </motion.div>
    </main>
  );
}
